"use client";

import { createCompositeStore } from "../__chunks/AJZ4BYF3.js";
import "../__chunks/CYQWQL4J.js";
import "../__chunks/7PRQYBBV.js";
import "../__chunks/BCALMBPZ.js";
import { defaultValue } from "../__chunks/PBFD2E7P.js";
import "../__chunks/DTR5TSDJ.js";
import { __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/toolbar/toolbar-store.ts
function createToolbarStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  var syncState = (_a = props.store) == null ? void 0 : _a.getState();
  return createCompositeStore(__spreadProps(__spreadValues({}, props), {
    orientation: defaultValue(props.orientation, syncState == null ? void 0 : syncState.orientation, "horizontal"),
    focusLoop: defaultValue(props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  }));
}
export { createToolbarStore };